// Copyright (c) 2026 Endel Dreyer.
//
// This software is released under the MIT License.
// https://opensource.org/license/MIT
//
// colyseus.js@0.17.22
class ServerError extends Error {
    code;
    headers;
    status;
    response;
    data;
    constructor(code, message, opts) {
        super(message);
        this.name = "ServerError";
        this.code = code;
        if (opts) {
            this.headers = opts.headers;
            this.status = opts.status;
            this.response = opts.response;
            this.data = opts.data;
        }
    }
}
class AbortError extends Error {
    constructor(message) {
        super(message);
        this.name = "AbortError";
    }
}
class MatchMakeError extends Error {
    code;
    constructor(message, code) {
        super(message);
        this.code = code;
        this.name = "MatchMakeError";
        Object.setPrototypeOf(this, MatchMakeError.prototype);
    }
}

export { AbortError, MatchMakeError, ServerError };
//# sourceMappingURL=Errors.mjs.map
